import * as React from 'react';

import { Col, DropDown, StyleSheet, breakPoint, color, font } from '@coursera/coursera-ui';
import { SvgChevronDown } from '@coursera/coursera-ui/svg';

import { MOST_HELPFUL_SORT_LABEL, MOST_RECENT_SORT_LABEL } from 'bundles/reviews/constants';
import type { ReviewRouter } from 'bundles/reviews/types/reviewTypes';

import _t from 'i18n!nls/reviews';

type Props = {
  sortByHelpfulVotes: boolean;
  router: ReviewRouter;
};

const styles = StyleSheet.create({
  sortByButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [`@media (max-width: ${breakPoint.md}px)`]: {
      justifyContent: 'flex-start',
      marginTop: '1rem',
    },
  },
});

class ReviewsSort extends React.Component<Props> {
  handleSortBySelect = (sortByHelpful: boolean) => {
    const {
      router,
      router: {
        location: { query: activeQueryParams },
      },
    } = this.props;

    router.replace({
      pathname: router.location.pathname,
      query: { ...activeQueryParams, sort: sortByHelpful ? 'helpful' : 'recent', page: 1 },
    });
  };

  renderSortButton = ({ getDropDownButtonProps }: { getDropDownButtonProps: () => {} }) => {
    const { sortByHelpfulVotes } = this.props;
    const sortByLabel = sortByHelpfulVotes ? MOST_HELPFUL_SORT_LABEL() : MOST_RECENT_SORT_LABEL();

    return (
      <button
        type="button"
        data-e2e="reviews-sort-dropdown"
        {...getDropDownButtonProps()}
        style={{
          fontSize: font.sm,
          width: 300,
          height: 48,
          display: 'flex',
          justifyContent: 'space-between',
          background: 0,
          padding: 15,
          lineHeight: 1,
        }}
      >
        <div>
          {_t('Sort by: ')} <b>{sortByLabel}</b>
        </div>
        <div>
          <SvgChevronDown size={18} color={color.black} hoverColor={color.secondaryText} />
        </div>
      </button>
    );
  };

  render() {
    return (
      <Col md={4} rootClassName={styles.sortByButton}>
        <DropDown.ButtonMenu menuStyle="d-inline-block border-a" renderButton={this.renderSortButton}>
          <DropDown.Item
            label={MOST_HELPFUL_SORT_LABEL()}
            onClick={() => this.handleSortBySelect(true)}
            htmlAttributes={{ 'data-e2e': 'reviews-sort-most-helpful' }}
          />
          <DropDown.Item
            label={MOST_RECENT_SORT_LABEL()}
            onClick={() => this.handleSortBySelect(false)}
            htmlAttributes={{ 'data-e2e': 'reviews-sort-most-recent' }}
          />
        </DropDown.ButtonMenu>
      </Col>
    );
  }
}

export default ReviewsSort;
